export const MenuItems = [
  {
    title: 'capital markets',
    path: 'capital-markets',
    cName: 'dropdownLink',
  },
  {
    title: 'investment research',
    path: 'investment-research',
    cName: 'dropdownLink',
  },
  {
    title: 'security dealings',
    path: 'security-dealings',
    cName: 'dropdownLink',
  },
  {
    title: 'advisory services',
    path: 'advisory-services',
    cName: 'dropdownLink',
  },
];
